/**
 * Client 200231856 ("Test, Kyle") exists only to test the app, but is booked with real coaches,
 * so their Mindbody schedules include it. Hidden from every viewer except the logins that use it.
 *
 * The app-wide helper (src/shared/utils/testClients.ts, isHiddenTestClient) is still unmerged work;
 * once it lands, this file should call it instead and be deleted. Keep the two lists identical.
 */
const TEST_CLIENT_IDS: ReadonlySet<string> = new Set(['200231856']);

const TEST_CLIENT_VIEWER_EMAILS: ReadonlySet<string> = new Set(['kyle@ufit.com.sg', 'kylewild76+5@gmail.com', 'kyle+1@ufit.com']);

/** True when this viewer should not see the client's sessions at all. */
export const isHiddenScheduleClient = (clientId: string, viewerEmail: string | null | undefined): boolean =>
  TEST_CLIENT_IDS.has(clientId.trim()) && !(viewerEmail && TEST_CLIENT_VIEWER_EMAILS.has(viewerEmail.trim().toLowerCase()));
